export let environment: { apiUrl: string; production: boolean, apiUrl1: string };
environment = {
	production: false,
	apiUrl: 'https://scrm-api.nirvytech.com/public',
	apiUrl1: 'http://localhost/realestate-api/public',

};

